import React from "react";
import './styles.css'
const Loader = () => {
  return (
    [<div class="modalLoading"></div>]
  );
};

export default Loader;
